export const trustCredibilityBlockText: string[] = [
  'Seriously afforable rent',
  'Fine-tuned roommate matching',
  'Access to a nationwide network of homes',
  'Fast Wi-fi, furnished common areas',
  'Easy transfer within our network',
  '24/7 member support'
]
